import * as THREE from 'three';
// Ground UI (rings, route lines, markers) draws after terrain and roads but is depth-tested, so characters and props always cover it.
// A flat decal draws both faces in one pass: three otherwise splits a transparent double-sided draw in two and re-selects its shader for each.
export const GROUND_DECAL_ORDER = 5;
/** Ground UI (rings, glyphs, order marks, pings) sits on this layer alone, so the picture filters can draw it after the filter pass and keep it crisp (`PICTURE_FILTERS.groundUi`). The cameras see it by default. */
export const GROUND_UI_LAYER = 6;
export function groundUi<T extends THREE.Object3D>(object: T): T { object.layers.set(GROUND_UI_LAYER); return object; }
export function groundDecal<T extends THREE.Mesh | THREE.Line>(object: T): T {
  const material = object.material as THREE.Material;
  material.transparent = true; material.depthTest = true; material.depthWrite = false; material.forceSinglePass = true;
  material.polygonOffset = true; material.polygonOffsetFactor = -4; material.polygonOffsetUnits = -4;
  object.renderOrder = GROUND_DECAL_ORDER;
  return object;
}
